"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Pill_meta_1 = require("../Pill.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('span', Pill_meta_1.PILL_CATEGORY_KEY, Pill_meta_1.PILL_COMPONENT_KEY, ['wrapper']);